import axios from "axios";
import * as headers from "../auth-header";

const apiUrl = process.env.REACT_APP_API_URL;

export function getAllSubscriptions(page, limit, filter) {
  return axios.get(apiUrl + `subscription/all/${page}/${limit}?key=${filter}`, {
    headers: headers.authHeader(),
  });
}
